var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import UserActionsAPI from '../../services/UserActionsAPI';
import _get from 'lodash/get';
import { observable, action, computed, makeObservable } from 'mobx';
import { Filters, IFilters } from '../../framework/factories/FilterFactory';
import { transformFiltersToQuery } from '../../framework/utils/FiltersUtils';
import { checkRangeValuesOnEqual } from '@bytebrand/fe-ui-core-autobahn/utils';
import { RANGE_FILTERS, OBJECT_FILTERS, MMS_GROUPS_ITEMS, MANUFACTURER_KEY, MODEL_KEY, SERIES_KEY, MMS_GROUPS_KEY, MMS_GROUP_OBJ, MODEL_EXCLUDE_KEY, SERIES_EXCLUDE_KEY, MM_GROUPS_EXCLUDE_KEY, MM_GROUP_EXCLUDE_OBJ, MANUFACTURER_EXCLUDE_KEY } from '../../framework/constants/search';
import { ShowNotificationError } from '../../framework/ErrorLogger';
import { toJSTransformer as toJS } from 'framework/utils/CommonUtils';
const updateValueInGroup = (group, filterKey, filterValue) => {
    const groupWithUpdatedValue = group;
    groupWithUpdatedValue[filterKey].value = filterValue;
    return Object.assign({}, group, groupWithUpdatedValue);
};
const updateOptionsInGroup = (group, filterKey, options) => {
    const groupWithUpdatedValue = group;
    groupWithUpdatedValue[filterKey].options = options;
    return Object.assign({}, group, groupWithUpdatedValue);
};
const checkGroupOnValues = (group) => {
    let needUpdate = false;
    Object.keys(group).map((title) => {
        const item = group[title];
        if (item.value) {
            needUpdate = true;
        }
    });
    return needUpdate;
};
class SearchFiltersStore {
    constructor() {
        Object.defineProperty(this, "filters", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable.map(Filters)
        });
        Object.defineProperty(this, "savedSearchStrings", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable.array([])
        });
        Object.defineProperty(this, "lastSearchString", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "addMmsGroup", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const filtersObj = toJS(this.filters);
                const mmsGroup = filtersObj[MMS_GROUPS_KEY];
                mmsGroup.push(MMS_GROUP_OBJ);
                this.filters.set(MMS_GROUPS_KEY, mmsGroup);
            }
        });
        // if group for delete is empty we don't need to refresh our search page
        Object.defineProperty(this, "removeMmsGroup", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (index) => {
                const filtersObj = toJS(this.filters);
                const mmsGroup = filtersObj[MMS_GROUPS_KEY];
                const needRefresh = checkGroupOnValues(mmsGroup[index]);
                mmsGroup.splice(index, 1);
                this.filters.set(MMS_GROUPS_KEY, mmsGroup);
                return needRefresh;
            }
        });
        Object.defineProperty(this, "addMmExcludeGroup", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const filtersObj = toJS(this.filters);
                const mmGroupExclude = filtersObj[MM_GROUPS_EXCLUDE_KEY];
                mmGroupExclude.push(MM_GROUP_EXCLUDE_OBJ);
                this.filters.set(MM_GROUPS_EXCLUDE_KEY, mmGroupExclude);
            }
        });
        Object.defineProperty(this, "removeMmExcludeGroup", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (index) => {
                const filtersObj = toJS(this.filters);
                const mmGroupExclude = filtersObj[MM_GROUPS_EXCLUDE_KEY];
                const needRefresh = checkGroupOnValues(mmGroupExclude[index]);
                mmGroupExclude.splice(index, 1);
                this.filters.set(MM_GROUPS_EXCLUDE_KEY, mmGroupExclude);
                return needRefresh;
            }
        });
        Object.defineProperty(this, "resetFiltersToDefault", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.filters.merge(Filters);
            }
        });
        // send index param only for update GROUPS values
        Object.defineProperty(this, "changeFilterValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (filterKey, filterValue, index) => {
                const filtersObj = toJS(this.filters);
                let newFilterValue = null;
                if (index >= 0) {
                    let groupKey = null;
                    // let newFiltersGroup: any = null;
                    if (filterKey.indexOf('EXCLUDE') !== -1) {
                        groupKey = MM_GROUPS_EXCLUDE_KEY;
                        newFilterValue = filtersObj[MM_GROUPS_EXCLUDE_KEY];
                    }
                    else {
                        groupKey = MMS_GROUPS_KEY;
                        newFilterValue = filtersObj[MMS_GROUPS_KEY];
                    }
                    newFilterValue[index][filterKey].value = filterValue;
                    this.filters.set(groupKey, newFilterValue);
                }
                else {
                    Object.keys(filtersObj).forEach((key) => {
                        if (key === filterKey) {
                            newFilterValue = Object.assign({}, filtersObj[key], { value: filterValue });
                            this.filters.set(key, newFilterValue);
                        }
                    });
                }
            }
        });
        Object.defineProperty(this, "changeSeries", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (filterKey, filterValue, index) => {
                const filtersObj = toJS(this.filters);
                let newFilterValue = null;
                let filter = null;
                let groupKey = null;
                if (filterKey.indexOf('EXCLUDE') !== -1) {
                    filter = SERIES_EXCLUDE_KEY;
                    groupKey = MM_GROUPS_EXCLUDE_KEY;
                    newFilterValue = filtersObj[MM_GROUPS_EXCLUDE_KEY];
                }
                else {
                    filter = SERIES_KEY;
                    groupKey = MMS_GROUPS_KEY;
                    newFilterValue = filtersObj[MMS_GROUPS_KEY];
                }
                newFilterValue[index][filter].value = filterValue;
                this.filters.set(groupKey, newFilterValue);
            }
        });
        // send index param only for chips from GROUPS fields
        Object.defineProperty(this, "changeChipFilter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (filterKey, filterValue, index) => {
                const filtersObj = toJS(this.filters);
                const isGroupFilter = MMS_GROUPS_ITEMS.indexOf(filterKey) !== -1;
                let groupKey = '';
                let modelKey = '';
                let seriesKey = '';
                if (isGroupFilter) {
                    const isExclude = filterKey.indexOf('EXCLUDE') !== -1;
                    groupKey = isExclude ? MM_GROUPS_EXCLUDE_KEY : MMS_GROUPS_KEY;
                    modelKey = isExclude ? MODEL_EXCLUDE_KEY : MODEL_KEY;
                    seriesKey = isExclude ? SERIES_EXCLUDE_KEY : SERIES_KEY;
                }
                const value = isGroupFilter ? filtersObj[groupKey][index][filterKey].value : filtersObj[filterKey].value;
                const valueType = typeof value;
                const isArray = Array.isArray(value);
                const newArrValue = value;
                let newFilterValue = null;
                if (valueType === 'object' && isArray) {
                    const valueIndex = value.indexOf(filterValue);
                    newArrValue.splice(valueIndex, 1);
                    newFilterValue = Object.assign({}, filtersObj[filterKey], { value: newArrValue });
                    this.filters.set(filterKey, newFilterValue);
                }
                if (valueType === 'object' && !isArray) {
                    const isRange = filtersObj[filterKey].isRange;
                    const isRate = filtersObj[filterKey].isRate;
                    const newFilterValue = Object.assign({}, filtersObj[filterKey], isRange ? { value: RANGE_FILTERS[filterKey].defaultValue, controls: { from: '', to: '' } } : {}, isRate ? { value: OBJECT_FILTERS[filterKey].defaultValue } : {});
                    this.filters.set(filterKey, newFilterValue);
                }
                if (valueType === 'string') {
                    if (index >= 0) {
                        const newFiltersObj = updateValueInGroup(filtersObj[groupKey][index], filterKey, '');
                        const seriesValue = _get(filtersObj, `${groupKey}.${index}.${seriesKey}.value`, '');
                        if (filterKey.indexOf(MANUFACTURER_KEY) !== -1) {
                            newFiltersObj[modelKey].value = '';
                            newFiltersObj[modelKey].options = [];
                            newFiltersObj[seriesKey].value = '';
                        }
                        if (seriesValue === filterValue) {
                            newFiltersObj[seriesKey].value = '';
                        }
                        newFilterValue = Object.assign([], filtersObj[groupKey], newFiltersObj);
                        this.filters.set(groupKey, newFilterValue);
                    }
                    else {
                        newFilterValue = Object.assign({}, filtersObj[filterKey], { value: '' });
                        this.filters.set(filterKey, newFilterValue);
                    }
                }
            }
        });
        Object.defineProperty(this, "addManufacturersToFilters", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (brands, clearModelValue = true) => {
                const filtersObj = toJS(this.filters);
                const includeLength = filtersObj[MMS_GROUPS_KEY].length;
                const excludeLength = filtersObj[MM_GROUPS_EXCLUDE_KEY].length;
                const maxLength = includeLength >= excludeLength ? includeLength : excludeLength;
                const newFilterObj = filtersObj;
                for (let i = 0; i <= maxLength; i += 1) {
                    if (filtersObj[MMS_GROUPS_KEY][i]) {
                        newFilterObj[MMS_GROUPS_KEY][i][MANUFACTURER_KEY].options = brands;
                    }
                    if (filtersObj[MM_GROUPS_EXCLUDE_KEY][i]) {
                        newFilterObj[MM_GROUPS_EXCLUDE_KEY][i][MANUFACTURER_EXCLUDE_KEY].options = brands;
                    }
                }
                this.filters.set(MMS_GROUPS_KEY, newFilterObj[MMS_GROUPS_KEY]);
                this.filters.set(MM_GROUPS_EXCLUDE_KEY, newFilterObj[MM_GROUPS_EXCLUDE_KEY]);
            }
        });
        Object.defineProperty(this, "addModelsToFilters", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (models, index) => {
                const filtersObj = toJS(this.filters);
                const newFiltersObj = filtersObj[MMS_GROUPS_KEY].map((group, i) => i === index ? updateOptionsInGroup(group, MODEL_KEY, models) : group);
                const filterValue = Object.assign([], filtersObj[MMS_GROUPS_KEY], newFiltersObj);
                this.filters.set(MMS_GROUPS_KEY, filterValue);
            }
        });
        Object.defineProperty(this, "addModelsToFiltersExclude", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (models, index) => {
                const filtersObj = toJS(this.filters);
                const newFiltersObj = filtersObj[MM_GROUPS_EXCLUDE_KEY].map((group, i) => i === index ? updateOptionsInGroup(group, MODEL_EXCLUDE_KEY, models) : group);
                const filterValue = Object.assign([], filtersObj[MM_GROUPS_EXCLUDE_KEY], newFiltersObj);
                this.filters.set(MM_GROUPS_EXCLUDE_KEY, filterValue);
            }
        });
        Object.defineProperty(this, "changeRangeFilterUpdateStatus", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (filterKey, status) => {
                const filtersObj = toJS(this.filters);
                Object.keys(filtersObj).forEach((key) => {
                    if (key === filterKey) {
                        this.filters.set(key, Object.assign({}, filtersObj[key], { onceUpdated: status }));
                    }
                });
            }
        });
        Object.defineProperty(this, "changeRangeFilterControls", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (filterKey, value) => {
                const filtersObj = toJS(this.filters);
                Object.keys(filtersObj).forEach((key) => {
                    if (key === filterKey) {
                        this.filters.set(key, Object.assign({}, filtersObj[key], { controls: value }));
                    }
                });
            }
        });
        Object.defineProperty(this, "addSavedSearchString", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (filters, query, emailAlert) => {
                const searchString = transformFiltersToQuery(filters);
                return UserActionsAPI.getSearchString()
                    .then((data) => {
                    this.savedSearchStrings = data;
                    if (!this.savedSearchStrings.some((data) => data.searchString.query == query)) {
                        return UserActionsAPI.addSearchString(searchString, this.chipsList, query, emailAlert)
                            .then((newSearchString) => {
                            this.savedSearchStrings.push(newSearchString);
                        })
                            .catch((error) => {
                            ShowNotificationError();
                            // re-throw so callers don't run their success branch (saved=true, success toast)
                            throw error;
                        });
                    }
                    else {
                        throw new Error('saveAlreadyExists');
                    }
                });
            }
        });
        // quiet: no error toast — for the Konto menu's count badge, loaded on every page after sign-in.
        Object.defineProperty(this, "getSavedSearchStrings", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (quiet = false) => {
                return UserActionsAPI.getSearchString()
                    .then((data) => {
                    this.savedSearchStrings = data;
                })
                    .catch(() => {
                    if (!quiet)
                        ShowNotificationError();
                });
            }
        });
        Object.defineProperty(this, "updateSavedSearchString", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (searchStringId, data) => {
                return UserActionsAPI.updateSearchString(searchStringId, data)
                    .then(() => {
                    this.getSavedSearchStrings();
                })
                    .catch((error) => {
                    ShowNotificationError();
                });
            }
        });
        Object.defineProperty(this, "deleteSavedSearchString", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (searchStringId) => {
                return UserActionsAPI.deleteSearchString(searchStringId)
                    .then(() => {
                    this.getSavedSearchStrings();
                })
                    .catch((error) => {
                    ShowNotificationError();
                });
            }
        });
        Object.defineProperty(this, "setLastSearchString", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (filters, query) => {
                this.lastSearchString = {
                    query,
                    ...transformFiltersToQuery(filters)
                };
            }
        });
        Object.defineProperty(this, "clearLastSearchString", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.lastSearchString = null;
            }
        });
        makeObservable(this);
    }
    get chipsList() {
        const filters = toJS(this.filters);
        const filtersKeys = Object.keys(filters);
        const chips = [];
        for (let i = 0; i < filtersKeys.length; i += 1) {
            const filterKey = filtersKeys[i];
            const filter = filters[filterKey];
            if (filterKey === MMS_GROUPS_KEY || filterKey === MM_GROUPS_EXCLUDE_KEY) { // eslint-disable-line
                filter.map((group, index) => {
                    Object.keys(group).forEach((mmsKey) => {
                        const mmsGroupKey = mmsKey;
                        const mmsGroupValue = group[mmsKey].value;
                        if (mmsGroupValue) {
                            chips.push({
                                index,
                                filterKey: mmsGroupKey,
                                filterValue: mmsGroupValue
                            });
                        }
                    });
                });
            }
            // CAR_IDS/SIMILAR_TO drive the recently-viewed "show all" / "Ähnlich wie dein X" links
            // (NewMainPage) — internal doc ids / anchor objects, never user-facing, so they must
            // never turn into one removable chip per entry (SIMILAR_TO's entries are OBJECTS —
            // chipLabel's default case would render "[object Object]").
            if (filterKey !== 'CAR_IDS' && filterKey !== 'SIMILAR_TO' && Array.isArray(filter.value) && filter.value.length) {
                filter.value.map((item) => (chips.push({
                    filterKey,
                    filterValue: item
                })));
            }
            if (typeof filter.value === 'string' && filter.value) {
                chips.push({
                    filterKey,
                    filterValue: filter.value
                });
            }
            if (filter.isRange || filter.isRate) {
                const FILTERS = filter.isRange ? RANGE_FILTERS : OBJECT_FILTERS;
                const defaultValue = FILTERS[filterKey].defaultValue;
                const valueIsDefault = checkRangeValuesOnEqual(defaultValue, filter.value);
                if (!valueIsDefault) {
                    chips.push({
                        filterKey,
                        filterValue: filter.value
                    });
                }
            }
        }
        return chips;
    }
}
__decorate([
    observable,
    __metadata("design:type", typeof (_a = typeof IFilters !== "undefined" && IFilters) === "function" ? _a : Object)
], SearchFiltersStore.prototype, "filters", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], SearchFiltersStore.prototype, "savedSearchStrings", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SearchFiltersStore.prototype, "lastSearchString", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], SearchFiltersStore.prototype, "chipsList", null);
__decorate([
    action,
    __metadata("design:type", Object)
], SearchFiltersStore.prototype, "addMmsGroup", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], SearchFiltersStore.prototype, "removeMmsGroup", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], SearchFiltersStore.prototype, "addMmExcludeGroup", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], SearchFiltersStore.prototype, "removeMmExcludeGroup", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], SearchFiltersStore.prototype, "resetFiltersToDefault", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], SearchFiltersStore.prototype, "changeFilterValue", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], SearchFiltersStore.prototype, "changeSeries", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], SearchFiltersStore.prototype, "changeChipFilter", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], SearchFiltersStore.prototype, "addManufacturersToFilters", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], SearchFiltersStore.prototype, "addModelsToFilters", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], SearchFiltersStore.prototype, "addModelsToFiltersExclude", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], SearchFiltersStore.prototype, "changeRangeFilterUpdateStatus", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], SearchFiltersStore.prototype, "changeRangeFilterControls", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], SearchFiltersStore.prototype, "addSavedSearchString", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], SearchFiltersStore.prototype, "getSavedSearchStrings", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], SearchFiltersStore.prototype, "updateSavedSearchString", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], SearchFiltersStore.prototype, "deleteSavedSearchString", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], SearchFiltersStore.prototype, "setLastSearchString", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], SearchFiltersStore.prototype, "clearLastSearchString", void 0);
export default new SearchFiltersStore();
